import React, { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PurpleColorTestPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <div className="w-full bg-white" data-id="element-4560">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-4561">
        <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-4562">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-4563" />
          <span data-id="element-4564">Go Back</span>
        </Link>
      </div>
      {/* Header with Purple Theme */}
      <header className="w-full bg-white py-4 px-6 md:px-12 border-b border-gray-100" data-id="element-4565">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-4566">
          <div className="flex items-center" data-id="element-4567">
            <a href="/" className="no-underline" data-id="element-4568">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rQktehvNa2Z7NATkWorM3j/Caveo_Update_Logo.png" alt="Caveo Logo" className="h-10 md:h-12" data-id="element-4569" />
            </a>
          </div>
          <nav className="hidden md:flex space-x-6" data-id="element-4570">
            <a href="/product" className="text-[#1A0933] no-underline hover:text-[#9966FF]" data-id="element-4571">
              Product
            </a>
            <a href="/about-us" className="text-[#1A0933] no-underline hover:text-[#9966FF]" data-id="element-4572">
              About Us
            </a>
            <a href="/resources" className="text-[#1A0933] no-underline hover:text-[#9966FF]" data-id="element-4573">
              Resources
            </a>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-4574">
            <a href="/login" className="text-[#1A0933] no-underline hover:text-[#9966FF] px-4 py-2 rounded-md" data-id="element-4575">
              Login
            </a>
            <a href="/signup" className="bg-[#3333CC] text-white px-4 py-2 rounded-md font-medium no-underline hover:bg-[#9966FF] transition-colors" data-id="element-4576">
              Start Now
            </a>
          </div>
          <div className="md:hidden" data-id="element-4577">
            <button onClick={toggleMenu} className="text-[#1A0933] focus:outline-none" data-id="element-4578">
              {isMenuOpen ? <XIcon size={24} data-id="element-4579" /> : <MenuIcon size={24} data-id="element-4580" />}
            </button>
          </div>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && <div className="md:hidden fixed inset-0 z-50 bg-white pt-20 px-6" data-id="element-4581">
            <div className="flex flex-col space-y-4" data-id="element-4582">
              <a href="/product" className="text-[#1A0933] text-xl py-2 no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-4583">
                Product
              </a>
              <a href="/about-us" className="text-[#1A0933] text-xl py-2 no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-4584">
                About Us
              </a>
              <a href="/resources" className="text-[#1A0933] text-xl py-2 no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-4585">
                Resources
              </a>
              <div className="pt-4 flex flex-col space-y-4" data-id="element-4586">
                <a href="/login" className="text-[#1A0933] text-center py-2 border border-gray-200 rounded-md no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-4587">
                  Login
                </a>
                <a href="/signup" className="bg-[#3333CC] text-white text-center py-2 rounded-md font-medium no-underline hover:bg-[#9966FF] transition-colors" onClick={toggleMenu} data-id="element-4588">
                  Start Now
                </a>
              </div>
            </div>
          </div>}
      </header>
      {/* Hero Section with Purple Theme */}
      <section className="w-full bg-[#1A0933] py-16 md:py-24" data-id="element-4589">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4590">
          <div className="flex flex-col items-center text-center max-w-3xl mx-auto" data-id="element-4591">
            <div className="inline-block bg-[#9966FF] bg-opacity-20 text-[#9966FF] px-4 py-1 rounded-full text-sm font-medium mb-8" data-id="element-4592">
              <span className="flex items-center" data-id="element-4593">
                <span className="mr-2" data-id="element-4594">🚀</span>
                Launching the future of family cyber security
              </span>
            </div>
            <h1 className="mb-6 text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight" data-id="element-4595">
              Protect your family from digital chaos
            </h1>
            <div className="mb-10 max-w-2xl mx-auto" data-id="element-4596">
              <p className="text-gray-300 text-lg" data-id="element-4597">
                Take our free digital safety assessment to see where your
                <br data-id="element-4598" />
                family's at risk and how you can fix it. No email required.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-12" data-id="element-4599">
              <Link to="/intro-assessment" className="bg-[#3333CC] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 no-underline hover:bg-[#9966FF]" data-id="element-4600">
                <span data-id="element-4601">Start Now</span>
                <ArrowRightIcon size={18} data-id="element-4602" />
              </Link>
              <a href="/learn-more" className="border border-[#9966FF] text-[#9966FF] px-6 py-3 rounded-md font-medium no-underline hover:bg-[#9966FF] hover:bg-opacity-10 transition-colors" data-id="element-4603">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Features Section with Purple Theme */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4604">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4605">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A0933] mb-6" data-id="element-4606">
            Why people love Caveo
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mb-16" data-id="element-4607">
            Thousands of users trust Caveo to protect their aging parents
            online. Get the tools, skills, and confidence to keep your loved
            ones safe from digital threats.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12" data-id="element-4608">
            <div className="flex gap-6" data-id="element-4609">
              <div className="flex-shrink-0" data-id="element-4610">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-4611">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4612" />
                </div>
              </div>
              <div data-id="element-4613">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4614">
                  Quick and easy to follow:
                </h3>
                <p className="text-gray-700" data-id="element-4615">
                  Learn how to protect your parents from scams in just 15
                  minutes a day—perfect for any family with seniors, regardless
                  of technical experience.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-4616">
              <div className="flex-shrink-0" data-id="element-4617">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-4618">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4619" />
                </div>
              </div>
              <div data-id="element-4620">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4621">
                  Comprehensive protection:
                </h3>
                <p className="text-gray-700" data-id="element-4622">
                  From email scam detection to secure banking setup, we provide
                  all the tools needed to shield your parents from digital
                  fraud.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-4623">
              <div className="flex-shrink-0" data-id="element-4624">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-4625">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4626" />
                </div>
              </div>
              <div data-id="element-4627">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4628">
                  Remote monitoring options:
                </h3>
                <p className="text-gray-700" data-id="element-4629">
                  Our app allows you to help manage your parents' digital
                  security even when you can't be there in person.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-4630">
              <div className="flex-shrink-0" data-id="element-4631">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-4632">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4633" />
                </div>
              </div>
              <div data-id="element-4634">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4635">
                  Practical and actionable:
                </h3>
                <p className="text-gray-700" data-id="element-4636">
                  Get clear, jargon-free guidance on how to secure devices,
                  recognize scams, and prevent fraud targeting seniors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section with Purple Theme */}
      <section className="w-full bg-[#9966FF] bg-opacity-10 py-16" data-id="element-4637">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4638">
          <div className="text-center mb-12" data-id="element-4639">
            <div className="flex justify-center space-x-2 mb-8" data-id="element-4640">
              <button className="w-3 h-3 rounded-full bg-[#3333CC]" data-id="element-4641"></button>
              <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-4642"></button>
              <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-4643"></button>
            </div>
            <blockquote className="text-2xl md:text-3xl font-medium text-[#1A0933] max-w-4xl mx-auto" data-id="element-4644">
              "After my mom nearly fell for a phishing scam, Caveo helped me set
              up proper protections that she could easily understand and use."
            </blockquote>
            <div className="mt-8" data-id="element-4645">
              <p className="text-[#1A0933] font-medium" data-id="element-4646">Michael Roberts</p>
              <p className="text-gray-500 text-sm" data-id="element-4647">
                Son of 72-year-old mother, Ohio
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section with Purple Theme */}
      <section className="w-full bg-[#1A0933] py-16 md:py-24" data-id="element-4648">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4649">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-4650">
            <div className="space-y-6" data-id="element-4651">
              <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-4652">
                Protect your aging parents from digital chaos today!
              </h2>
              <p className="text-lg text-gray-300" data-id="element-4653">
                Take the first step toward safeguarding your parents from scams,
                fraud, and digital threats with our comprehensive protection
                tools.
              </p>
              <div className="pt-4" data-id="element-4654">
                <Link to="/intro-assessment" className="bg-[#3333CC] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center sm:justify-start space-x-2 no-underline hover:bg-[#9966FF] inline-flex" data-id="element-4655">
                  <span data-id="element-4656">Start Now</span>
                  <ArrowRightIcon size={18} data-id="element-4657" />
                </Link>
              </div>
            </div>
            <div className="relative" data-id="element-4658">
              <div className="bg-white p-4 rounded-lg shadow-xl overflow-hidden" data-id="element-4659">
                <img src="https://images.unsplash.com/photo-1591035897819-f4bdf739f446?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Family using digital devices safely" className="w-full h-auto rounded-md" data-id="element-4660" />
                <div className="absolute top-2 left-2 flex space-x-1" data-id="element-4661">
                  <div className="w-3 h-3 bg-red-500 rounded-full" data-id="element-4662"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-full" data-id="element-4663"></div>
                  <div className="w-3 h-3 bg-green-500 rounded-full" data-id="element-4664"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer with Purple Theme */}
      <footer className="w-full bg-white py-12 border-t border-gray-100" data-id="element-4665">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4666">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-4667">
            <div data-id="element-4668">
              <div className="text-2xl font-bold text-[#3333CC] mb-6" data-id="element-4669">
                Caveo
              </div>
              <ul className="space-y-3" data-id="element-4670">
                <li data-id="element-4671">
                  <a href="/" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4672">
                    Home
                  </a>
                </li>
                <li data-id="element-4673">
                  <a href="/resources" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4674">
                    Resources
                  </a>
                </li>
                <li data-id="element-4675">
                  <a href="/support" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4676">
                    Support center
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-4677">
              <div className="text-lg font-semibold text-[#1A0933] mb-6" data-id="element-4678">
                Legal
              </div>
              <ul className="space-y-3" data-id="element-4679">
                <li data-id="element-4680">
                  <a href="/privacy" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4681">
                    Privacy policy
                  </a>
                </li>
                <li data-id="element-4682">
                  <a href="/terms" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4683">
                    Terms and conditions
                  </a>
                </li>
                <li data-id="element-4684">
                  <a href="/subscription" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4685">
                    Subscription terms
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-4686">
              <div className="text-lg font-semibold text-[#1A0933] mb-6" data-id="element-4687">
                Disclaimer
              </div>
              <p className="text-gray-600 text-sm" data-id="element-4688">
                Caveo as a family protection platform does not monitor private
                communications. Please consult with your family before making
                any safety decisions. There is no bias towards or against any
                online platforms mentioned in this page.
              </p>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center" data-id="element-4689">
            <div className="mb-4 md:mb-0" data-id="element-4690">
              <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on App Store" className="h-10 inline-block mr-4" data-id="element-4691" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" className="h-10 inline-block" data-id="element-4692" />
            </div>
            <div className="text-sm text-gray-500" data-id="element-4693">
              © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>;
}